import { useState } from 'react';
import { Redirect } from "react-router-dom";
import Cookies from 'universal-cookie';
import './IP_search.css'
import { captureException } from '@sentry/browser';
import Button from '../Button/Button';

export default function IP_search(){


  const cookies = new Cookies();

  const[ip_search,set_ip_search]=useState("1");
  const[valid_ip,set_valid_ip]=useState(false);
  const[accounts, set_accounts]=useState([]);
  const[users,set_users]=useState([]);
  const[clicked,set_clicked]=useState(false)

  function trigger(){
      
        var options = {
          'method': 'POST',
          'url': process.env.REACT_APP_INFRA_SERVICE_URL+"/ip/get_user_by_ip/" ,
          'headers': {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            "ip": ip_search,
          })
        };
        fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/ip/get_user_by_ip/" , options).then(response=>response.json())
        .then(async data=>{ 
          if (data.err){
            const event_id = captureException(data.err);
            console.log('error logged', { event_id }); 
          }
            try{
              const res = data;
              set_accounts(res.accounts);
              set_users(res.users);
             
            }
            catch(error){
              const event_id = captureException(error);
              console.log('error logged', { event_id });
              
            }
            
        });
        set_clicked(true);
    }

    function handle_ip_search_text(e) {
      var value = e.target.value;
      const regex = new RegExp('((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))');
      set_valid_ip(regex.test(value));
      set_ip_search(value);
    }
  
    if(cookies.get("code")==undefined) {
      return <Redirect to="/login" />;
    }

  return (
      <div className="text" class="split right">
        <div className="container">
        <div>
          
            <label>
              enter IP 
            </label>
              <input  className="w3-input"
                type="text" 
                name="name"
                onChange={handle_ip_search_text} />
            
            
        </div>

          <div style={{"margin-top": "1em"}}>
            <Button onClick={()=>trigger()} disabled={!valid_ip} text="search accounts" class="main"/>
          </div>
          { clicked && users.length==0 && accounts.length==0 && <div className="text">There is no client with this ip </div> }
          {clicked &&  users && users.length>0 ? 
          (
            <div> <h2>users</h2>
              {users.map((user,i) =>
              <li key={user.id}> 
              <a href= {`https://frame.workiz.com/frame/account.php?acid=${user.account_id}`} target="_blank"> {user.name} </a>
              <div>user id: {user.id}</div>
              <div>account name: {user.account.account_name} </div>
            </li>)}</div> 

          ): 
          (
            <div></div>
          )}
          {clicked && accounts && accounts.length>0 ? 
          (
            <div><h2>accounts</h2>
              {accounts.map((account,i) =>
              <li key={account.id}> 
              <a href= {`https://frame.workiz.com/frame/account.php?acid=${account.id}`} target="_blank"> {account.account_name} </a>
            </li>)}</div> 

          ): 
          (
            <div></div>
          )}
          <div className="ip_description">
            <p>Sometimes, we have suspicious activity from a particular IP and we want to know which user or account it is.</p>
            <p>For this, you can enter the IP address and you can get back all the users and accounts who did operations from this IP.</p>
           <p>(The search was performed in the account table and users table in SQL)</p>
          
          </div>
        </div>
      </div>
  )
}
